import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Config } from '../_store';
import { DateUtilsService } from './dateUtils';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  appLoading: false;

  constructor(private dateUtils: DateUtilsService) { }

  replaceAll(str, valToReplace, replaceWith = '') {
    return str.replace(new RegExp(valToReplace, 'g'), replaceWith);
  }

  displayNumberAsCurrency(num) {
    const formattedNum = this.formatNumberAsINR(num);
    return `${Config.currencySymbolConfig.codeSymbol}${formattedNum}`;
  }

  displayNumberAsCurrencyFlag(num, currCode) {
    const formattedNum = this.formatNumberAsINR(num);
    return `${currCode}${formattedNum}`;
  }

  formatNumberAsINR(num) {
    num = this.roundNumToTwoDecimalPlace(num || 0);
    const formatNum = (numToFormat) => numToFormat.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
    const numStr = num.toString().split('.');
    // return numStr.length > 1 ? `${formatNum(numStr[0])}.${numStr[1]}` : `${formatNum(numStr[0])}.00`;
    return (numStr.length > 1) ? (numStr[1].length <=1) ? `${formatNum(numStr[0])}.${numStr[1]}0`:`${formatNum(numStr[0])}.${numStr[1]}` : `${formatNum(numStr[0])}.00`;
  }

  formatNumberAsCurrencyWithLocale(num, localeConfig, currency) {
    if (!currency) {
      return this.formatNumberAsINR(num);
    }
    try {
      const currFormat: any = Intl.NumberFormat(localeConfig.locale, {
        style: "currency",
        currency: currency.trim(),
      });
      if (localeConfig.customSymbol) {
        const parts = currFormat.formatToParts(num || 0);
        if (localeConfig.replaceDefault) {
          return parts.map((p, nIndex) => {
            if (nIndex === 0) {
              return localeConfig.customSymbol
            } else {
              return p.value;
            }
          }).join('');
        } else {
          return `${localeConfig.customSymbol}${currFormat.format(num || 0)}`;  
        }
      } else {
        return currFormat.format(num || 0);
      }
    } catch (err) {
      return this.formatNumberAsINR(num);
    } 
  }

  roundNumToTwoDecimalPlace(num) {
    return Math.round(num * 100) / 100;
  }

  roundNumToDecimalPlaceN(num, n) {
    return Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
  }

  getRandomNo(maxNo) {
    return Math.round(Math.random() * maxNo);
  }

  getCurrentPlatForm() {
  }

  getPathToNavigate(path) {
    return [`/${path}/${Date.now()}`]
  }

  getDummyObservable(data = {}) {
    let dummy: BehaviorSubject<any> = new BehaviorSubject<any>(data);
    let dummyObserver: Observable<any> = dummy.asObservable();
    return dummyObserver;
  }

  getToday() {
    return this.dateUtils.getToday();
  }

  getMaxDateForAdvancePay() {
    return this.dateUtils.addYearsToDate(this.getToday(), 1);
  }

  ellipsifyMsg(msg, length) {
    const len = msg.length;
    if (len <= length) {
      return msg;
    } else {
      return msg.substring(0, length) + "...";
    }
  }

  isEmailAddress(str) {
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;
    return pattern.test(str);  // returns a boolean
  }

  isMobileNo(str) {
    var pattern = /^[0-9]{9,10}$/;
    return pattern.test(str);  // returns a boolean
  }


}

